<template class="events-view-bg" data-app>
    <div style="height: 100%;">
      <!-- Botões de Status no topo -->
      <!-- TODO: FIXME: Hide this when not in calendar mode! -->
      
      <v-row style="height: 100%;">
        <!-- Coluna da esquerda -->
        <v-col  :class="[
            'left-column',
            'pa-0',
            selected === 'calendar'
              && toggleHours 
              && selectedDate 
              && !isMobile ? 'expanded' : '',
          ]"
        >
          <mc-progress-bar 
            :label="'Obtendo informações do evento...'"
            :active="fetching && showLoaderBar"
            color="bg_secondary"
            class="flex-shrink-0"
            :errorLabel="failedFetching ? 'Erro a carregar informação do evento! Atualize a página para tentar novamente.' : ''"
          />
          <div class="flex-grow-1" style="width: 100%;">

              <div 
                v-if="eventName"
                class="event-title-container feathered-edges bottom barra-rosa">
                <div class="event-title-wrapper">
                  <v-btn fab x-small outlined @click="openInviteDialog" class="">
                      <v-icon>mdi-account-plus</v-icon>
                  </v-btn>
                  <h1 @click="navigateToEventEdit" class="event-title">
                      {{ eventName }}
                  </h1>
                </div>
                <!-- Availability buttons -->
                <div
                    v-if="selected === 'calendar' && ((!fetching && !failedFetching) || !showLoaderBar)"
                    class="selection-container ">
                    <div class="buttons-row">
                      <!--  -->
                      <v-btn
                        v-for="(option, index) in options"
                        :key="index"
                        :class="[
                            option.class, 
                            // set the current button as active if its value matches selectedOption
                            // otherwise automatically select option 0 (clear button)
                            {'active-button': selectedOption === option.value || (!selectedOption && !option.value)},
                            'status-button',
                          ]"
                        @click="onOptionSelected(option.value)"
                        fab x-small outlined dense
                        :data-value="option.value"
                      />
                      
                    </div>
                </div>
                <!-- availability vote mode switch -->
                <div 
                  v-if="selected === 'calendar' && eventDuration == 'hours' && ((!fetching && !failedFetching) || !showLoaderBar)"
                  :class="[
                      'icon-switch-container',
                      { display: selected === 'results' ? 'hidden' : '' },
                    ]" 
                  >
                  <v-switch
                      v-model="toggleHours"
                      class="custom-switch"
                      color="text_primary"
                      @change="updateToggleHours"
                      hide-details
                  >
                    <template v-slot:prepend>
                      <v-icon 
                        color="text_primary"
                        @click.stop="setToggleState(false)"
                      >mdi-calendar-today-outline</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon 
                        color="text_primary"
                        @click.stop="setToggleState(true)"
                      >mdi-clock-outline</v-icon>
                    </template>
                  </v-switch>
                  <!-- <v-icon color="black" >mdi-clock-outline</v-icon> -->
                </div>
              </div>
              <!-- <div class="d-flex align-items-center justify-content-between">


              </div> -->

              <div class="d-flex flex-grow-1" style="height: 100%;">
                <EventDates
                  ref="eventDates"
                  v-show="selected === 'calendar'"
                  :eventId="eventId"
                  :eventDates="eventDates"
                  :eventTimes="eventTimes"
                  :toggleHours.sync="toggleHours"
                  :selectedDate="selectedDate"
                  :eventDuration="eventDuration"
                  :eventDurationValue="eventDurationValue"
                  :selected="selected"
                  :selectedOption.sync="selectedOption"
                  :updateToggleHours="updateToggleHours"
                  :isMobile="isMobile"
                  :reloadedEvents="reloadedEvents"
                  :eventTimesDialog.sync="eventTimesDialog"
                  :savingTimes.sync="savingTimes"
                  :loadEvent="loadEvent"
                  @date-selected="onDateSelected"
                  @option-selected="onOptionSelected"
                  @date-changed="onDateChanged"
                  context="event-availability"
                />
                <EventResults
                  v-if="selected === 'results'"
                  :eventId="eventId"
                  :eventDuration="eventDuration"
                  :eventDates="eventDates"
                  :fetching.sync="fetchingResults"
                  :selectedEvent.sync="selectedEvent"
                />
              </div>
          </div>
            
          <div 
            v-if="eventHash"
            class="custom-toggle-container feathered-edges top justify-center flex-shrink-0"
          >
            <div v-if="selected === 'results'" class="div-close-date-btn">
                <v-btn 
                  color="white"  
                  @click="closeEvent" 
                  class="close-date-btn text-none"
                  :disabled="fetchingResults"
                >
                Fechar data
              </v-btn>
            </div>
            <!-- 
                MC-337 - Alice Serina - 11/02/2026
                had to move this out of left-column so it was visible / accessible at any page length / y position
            -->
            <v-btn-toggle v-model="selected" mandatory class="custom-toggle">
                <v-btn value="calendar" :class="{'active-btn': selected === 'calendar'}">
                    <v-icon v-if="false" :class="selected === 'calendar' ? 'icon-active-calendar' : 'icon-inactive'">mdi-tune</v-icon> disponibilidade
                </v-btn>
                <v-btn value="results" :class="{'active-btn': selected === 'results'}" elevation="0">
                  resultados<v-icon v-if="false" :class="selected === 'results' ? 'icon-active-results' : 'icon-inactive'">mdi-calendar-check-outline</v-icon> 
                </v-btn>
            </v-btn-toggle>
          </div>

        </v-col>
  
        <!-- Coluna da direita -->
        <v-col cols="12" md="6" class="right-column">
            <v-img
              src="@/assets/papelEventos1.png"
              alt="Imagem de Login"
              max-width="100%"
              height="auto"
              contain
              class="img_size"
            />
        </v-col>
      
      </v-row>

      

      <!-- Dialog para partilhar link -->
      <v-dialog v-model="inviteDialog" max-width="500px">
          <v-card>
              <v-card-title
                    class="headline background-image modal-partilhar-title">Partilhar Link<v-spacer></v-spacer>
                  <v-btn color="red" icon @click="inviteDialog = false" class="btn-left"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                  <v-text-field
                      v-model="inviteLink"
                      label="Link de Convite"
                      prepend-icon="mdi-link"
                      readonly
                  ></v-text-field>
                  <v-btn icon @click="copyLink"><v-icon>mdi-content-copy</v-icon></v-btn>
                  <v-btn icon @click="shareLink"><v-icon>mdi-share-variant</v-icon></v-btn>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  
              </v-card-actions>
          </v-card>
      </v-dialog>
      <Help :show="openHelpModal" @close="openHelpModal = false" />
      
    </div>
    
  </template>
  
  <script>
  import Events from '@/api/Events.js';
  import EventDates from '@/components/events/EventDates.vue';
  // import EventTimes from '@/components/events/EventTimes.vue';
  import EventResults from '@/components/events/EventResults.vue';
  import Help from '@/views/Help.vue'
  // import dayjs from 'dayjs'
  // import 'dayjs/locale/pt'
  
  export default {
    components: {
      EventDates,
      // EventTimes,
      EventResults,
      Help
    },
    data() {
      return {
        reloadedEvents: 0,
        eventId: this.$route.params.id,
        eventName: '',
        eventDescription: '',
        openHelpModal: false,
        eventDates: [],
        eventTimes: {},
        eventDurationValue: 0,
        selectedDate: null,
        selectedOption: 0,
        selectedOptions: {},
        selected: 'calendar',
        selectedTimes: '',
        inviteDialog: false,
        inviteLink: '',
        eventHash: '',
        eventDuration: '',
        eventTimesDialog: false,
        isMobile: window.innerWidth < 769,
        toggleHours: false,
        eventDatesKey: 0,
        selectedColors: {},
        options: [
          { value: 1, class: 'red-button' },
          { value: 2, class: 'yellow-button' },
          { value: 3, class: 'green-button' },
          { value: 0, class: 'x-button' },
        ],
        fetching: false,
        showLoaderBar: true,
        failedFetching: false,
        savingTimes: false,
        fetchingResults: false,
        selectedEvent: {},
      };
    },

    watch: {
      
    },

    computed:{
    },
    
    methods: {
      closeEventTimes() {
          this.selectedDate = '';
      },

      formatDate(date) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Intl.DateTimeFormat('pt-BR', options).format(new Date(date));
      },

      checkUserInEvent() {
        try {
            const resp = Events.checkUserInEvent(this.eventId);
            console.log("USER VERIFICADO +++++++++++++++",resp);
        } catch (error) {
            console.error(' Erro:: ', error);
        }
      },
      setToggleState(newState) {
        // prevent doing anything if it's already in that state
        if (this.toggleHours === newState) return;

        // 2. Update the v-model
        this.toggleHours = newState;

        // 3. Manually call your existing change method
        this.updateToggleHours();
      },
      updateToggleHours() {
        this.selectedDate = null
      },

      // MC-337 - Alice Serina - 12/02/2026
      // moved this function here (from components/EventResults) since close-date-btn also moved here
      async closeEvent() {
        if (!this.selectedEvent) return;

        const payload = {
          event_id: this.eventId,
          duration: this.eventDuration,
          date: this.selectedEvent.date,
          start_time: this.eventDuration == 'hours' ? this.selectedEvent.date + ' ' + this.selectedEvent.start_time : this.selectedEvent.start_date.split(" - ")[0],
          end_time: this.eventDuration == 'hours' ? this.selectedEvent.date + ' ' + this.selectedEvent.end_time : this.selectedEvent.end_date.split(" - ")[0],
          total_participants: this.selectedEvent.total_participants,
          votes: this.selectedEvent.votes ? { ...this.selectedEvent.votes } : {}
        };


        try {
          await Events.closeEvent(payload);
          
          this.selectedEvent = null;

          this.$router.push({ name: 'Events' });

        } catch (error) {
          console.error("Erro ao fechar evento:", error);
          alert("Erro ao fechar evento.");
        }
      },

      async loadEvent(show_loader = true) {
        console.log("AGORA VOU CARREGAR O EVENTO")
        this.fetching = true;
        this.showLoaderBar = show_loader
        this.failedFetching = false;
        try {
          const response = await Events.get(this.eventId);
          const newEventDates = [];
          const newEventTimes = {};
          if (response.data.closed == 1) {
            this.$router.push('/home');
            return;
          }

          if(response.data.preferencial_date_start != null && response.data.preferencial_date_end != null){
            this.$router.push('/event-is-closed/' + this.eventId)
            return
          }

          this.eventName = response.data.title || 'Evento Sem Nome';
          this.eventDescription = response.data.description || 'Sem descrição';
          this.eventHash = response.data.sharable;
          this.eventDuration = response.data.duration_type;
          this.eventDurationValue = response.data.min_duration;


          if (Array.isArray(response.data.intervals)) {
            response.data.intervals.forEach(interval => {
              const startDateTime = interval.start_datetime; // "YYYY-MM-DD HH:mm:ss"
              const endDateTime = interval.end_datetime;     // "YYYY-MM-DD HH:mm:ss"

              const startDate = startDateTime.split(' ')[0];
              const endDate = endDateTime.split(' ')[0];
              const startTime = startDateTime.split(' ')[1].slice(0, 5); // "HH:mm"
              const endTime = endDateTime.split(' ')[1].slice(0, 5);     // "HH:mm"

              let currentDate = new Date(startDate);
              const lastDate = new Date(endDate);

              while (currentDate <= lastDate) {
                const dateStr = currentDate.toISOString().split('T')[0];

                if (!newEventDates.includes(dateStr)) {
                  newEventDates.push(dateStr);
                }

                if (!newEventTimes[dateStr]) {
                  newEventTimes[dateStr] = [];
                }

                // Adiciona horários de início e fim nos dias correspondentes
                if (dateStr === startDate) {
                  newEventTimes[dateStr].push({ time: startTime, value: null });
                }
                if (dateStr === endDate) {
                  newEventTimes[dateStr].push({ time: endTime, value: null });
                }

                currentDate.setDate(currentDate.getDate() + 1);
              }
            });
          }

          // Processa votos para preencher os valores dos horários
          if (Array.isArray(response.data.votes)) {
            response.data.votes.forEach(vote => {
              const [dateStr, timeStr] = vote.vote_start.split(' ');
              const hhmm = timeStr.slice(0, 5);
              let timeStr_end = vote.vote_end.match(/\d{1,2}:\d{1,2}(:\d{1,2})?/g) || [];
              
              // Add ":00" to the end of timeStr_end if it comes in the format hh:mm for some reason
              if (timeStr_end.length ) {
                timeStr_end = timeStr_end[0];
                if((timeStr_end.match(/:/g) || []).length)
                {
                  if(!timeStr_end.endsWith(":00"))
                  {
                    timeStr_end = `${timeStr_end}:00`;
                  }

                }
              }

              if (!newEventTimes[dateStr]) {
                newEventTimes[dateStr] = [];
              }

              // MC-330 - Alice Serina - 30/03/2026
              // turning whole day votes into separate hour block votes so they get
              // properly accounted for
              if(response.data.duration_type == "hours"
                  && (timeStr     == "00:00:00")
                  && (timeStr_end == "23:59:00")
              ) {
                for (let minutesSinceMidnight = 0; minutesSinceMidnight < 24 * 60; minutesSinceMidnight += 30) {
                  const hours = String(Math.floor(minutesSinceMidnight / 60)).padStart(2, "0");
                  const minutes = String(minutesSinceMidnight % 60).padStart(2, "0");

                  newEventTimes[dateStr].push({
                    time: `${hours}:${minutes}`,
                    value: vote.vote_value
                  });
                }
              }
              else {
                const timeObj = newEventTimes[dateStr].find(t => t.time === hhmm);

                if (timeObj) {
                  timeObj.value = vote.vote_value;
                }
                else {
                  newEventTimes[dateStr].push({
                    time: hhmm,
                    value: vote.vote_value
                  });
                }
              }
            });
          }
          this.eventDates = newEventDates;
          this.eventTimes = newEventTimes;

          console.log('✅ Dados do evento carregados:', this.eventDates, this.eventTimes);

        } catch (error) {
          this.failedFetching = true;
          console.error('❌ Erro ao carregar evento:', error);
          this.eventDates = [];
          this.eventTimes = {};
        }
        finally {
          this.fetching = false;
        }
      },
        
      onDateSelected({ date, option }) {
        if (!this.toggleHours) {
          this.selectedDate = date;
          this.selectedOption = option;
      

          if (this.eventTimes[date]) {
            this.eventTimes[date].forEach(time => {
              time.value = option; 
            });

            // Dispara o evento para salvar no backend
            this.$refs.eventDates.saveTimes().then(() => {

              this.$set(this.eventTimes, date, [...this.eventTimes[date]]);
              this.reloadedEvents++;

              this.$emit('reload-calendar');
            }).catch(error => {
              console.error('❌ Erro ao guardar horários:', error);
            });
            this.$emit('reload-calendar');
          }

          if (!this.eventTimes[date] || !Array.isArray(this.eventTimes[date])) {
            this.$set(this.eventTimes, date, []);
          }

          this.reloadedEvents++;

          if (this.isMobile) {
            this.eventTimesDialog = true;
          }
        }else{
          if (this.isMobile) {
            this.eventTimesDialog = true;
          }
        }
      },
      onOptionSelected(option) {
        this.selectedOption = option;
      },
      onTimeSelected({ time, option }) {
        if (!this.selectedOptions[this.selectedDate]) {
          this.$set(this.selectedOptions, this.selectedDate, {});
        }
        this.$set(this.selectedOptions[this.selectedDate], time, option);
        this.reloadedEvents ++;
        console.log('Hora selecionada:', time);
        console.log('Opção selecionada:', option);
        console.log('Selected options:', this.selectedOptions);

        this.selectedTimes = time;
        

      },

      onDateChanged(date) {
        this.selectedDate = date;
        if (this.$refs.eventTimes && this.$refs.eventTimes.saveTimes) {
        this.$refs.eventTimes.saveTimes().then(() => {
          this.eventTimes[date] = [...this.eventTimes[date]]; // Atualiza os horários
          this.reloadedEvents++; // Incrementa o contador
          console.log('✅ Horários guardados com sucesso: this.eventTimes[date]');
        }).catch(error => {
          console.error('❌ Erro ao guardar horários:', error);
        });
      }
        
      },

      openInviteDialog() {
        this.generateInviteLink(this.eventHash);
        this.inviteDialog = true;
      },


      generateInviteLink(hash) {
        this.inviteLink = `${window.location.origin}/event/hs/${hash}`;
      },

      copyLink() {
        navigator.clipboard.writeText(this.inviteLink).then(() => {
            console.log('Link copiado para a área de transferência');
        }).catch(err => {
            console.error('Erro ao copiar o link:', err);
        });
      },

      shareLink() {
        if (navigator.share) {
            navigator.share({
            title: 'Convite para Evento',
            text: 'Participe no evento ' + this.eventName + '!',
            url: this.inviteLink
            }).then(() => {
            console.log('Link compartilhado com sucesso');
            }).catch(err => {
            console.error('Erro ao compartilhar o link:', err);
            });
        } else {
            console.error('API de compartilhamento não suportada');
        }
      },      
      async saveTimesBeforeNavigation() {
        try {
            await this.$refs.eventDates.saveTimes();
            console.log("✅ ✅ Horários salvos com sucesso: this.$refs.eventDates.saveTimes");
        } catch (error) {
            console.error("❌ Erro ao salvar horários:", error);
        }
      },
      navigateToEventCreate() {
        console.log('A gravar no botão do titulo');
          //await this.saveTimesBeforeNavigation();
          this.$router.push({ name: 'EventsCreate', params: { id: this.eventId } });
      },
      navigateToEventEdit() {
        this.$router.push({ name: 'EventEdit', params: { id: this.eventId, name: this.eventName } });
      },

      async navigateToResults() {
        console.log('A gravar no botão dos resultados');
          await this.saveTimesBeforeNavigation();
          this.selected = 'results';
      }
    },

    handleClickOutside(event) {
        const eventTimesElement = this.$refs.eventTimes?.$el;
        
        if (eventTimesElement && !eventTimesElement.contains(event.target)) {
        this.selected = '';
        }
    },

    updateIsMobile() {
        this.isMobile = window.innerWidth < 769;
        console.log("Mobile: ", this.isMobile);
        this.eventTimesDialog = this.isMobile;
    },

    created() {
      this.eventName = this.$route.params.title;
      this.loadEvent();
      this.checkUserInEvent();
      
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        window.addEventListener('resize', this.updateIsMobile);

        console.log("OLHA")
        console.log(this.$root.session.first_login)
        
        if(this.$root.session.first_login == 0){
          this.openHelpModal = true
          this.$root.session.first_login = 1
        }
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('resize', this.updateIsMobile);
    },


  };
  </script>
  
  <style scoped>

  .fade {
    position: fixed;
    background: linear-gradient(to bottom, rgba(233, 207, 237, 1), rgba(233, 207, 237, 0.2) 100%, transparent 100%);
    width: 100%; height: 20px; z-index: 10;
  }

  ::v-deep(.v-input--selection-controls__input input:checked ~ .v-input--switch__track) {
    background-color: #000 !important;
    border: 1px solid  #000!important;
    opacity: 1 !important;
  }

  ::v-deep(.v-input--selection-controls__input input:not(:checked) ~ .v-input--switch__track) {
    background-color: #D9D9D9 !important;
    border: 1px solid  #000!important;
    opacity: 1 !important;
  }

  ::v-deep(.v-input--switch__thumb) {
    background-color: #e9cfed !important;
    border: 1px solid black !important;
  }

  .event-title-wrapper
  {
    display: flex;
    align-items: baseline;
    width: 100%;
    gap: 1rem;

  }

  .event-title-container {
    --gap : 1rem;
    display: flex;
    align-items: center;
    flex-grow: 1;
    flex-grow: 0;
    position: sticky;
    flex-wrap: wrap;
    top: var(--app-height-header-desktop);
    z-index: 4;
    padding-bottom: 0.5rem;
    background-color: var(--app-color-bg-primary);
    @media (max-width: 728px) {
      top: var(--app-height-header-mobile);
    }
  }
  .event-title-container .event-title-wrapper > *,
  .event-title-container .buttons-row > button,
  .event-title-container .icon-switch-container > *:is(i, .custom-switch)
  {
    cursor: pointer;
  }

  
  .event-title-container .selection-container
  {
    /* max-width: 450px; */
    max-width: var(--max-sub-col-width);
  }
  .event-title-container .selection-container
  ,
  .event-title-container .icon-switch-container
  {
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 1rem;
    width: auto;

    @media (max-width: 960px) {
      max-width: 50%;
      min-width: unset;
    }
  }
  .event-title-container .icon-switch-container 
  {
    @media (max-width: 960px) {
      justify-content: flex-end;
    }
  }
  
  
  .event-title-container .event-title {
    font-size: 1.5em;
    color: black;
    text-decoration: underline;
    flex: 1 0 50%;
  }

  /* btn toggle */
  /* Container Principal */
  .custom-toggle-container {
    position: sticky;
    bottom: 0px; 
    width: 100%;
    /* max-width: 450px; */
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #E9CFED;
    margin-top: 3rem;
    padding-bottom: 1rem;
    margin-top: 0rem;
    padding-bottom: 0.5rem;
    z-index: 1;
    /* 
      MC-318 - Alice Serina - 05/02/2026
      moved the close-data-btn element inside .custom-toggle-container
      to make it easier to style and match design

    */

    /* position: fixed;
    width: fit-content; */
    /* left: calc(max(10%, 64px) + (max(59%, 450px) / 4)); */
    /* left: calc((max(59%, 450px) / 2) - (max(10%, 64px)) / 3); */
    /* left: 0; */
    /* left: calc((max(59%, 450px) / 2)); */
    .div-close-date-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 60px;
      /* 
        MC-318 - Alice Serina - 05/02/2026
        288px is the minimum screen supported witdth (320px with 16px padding on each side).
        max-width is set to avoid becoming as wide as the screen
      */
      min-width: 288px;
      max-width: 360px;
      background-color:  #E9CFED;

      button {
        margin: 0 auto 16px;
        width: 100%;
        border-radius: 25px;
      }
    }
  }

/* Estilo da Toggle */
/* !!! between event availability and results */
.custom-toggle {
    display: flex;
    border-radius: 30px;
    overflow: hidden;
    align-items: center;
    width: 100%;
    height: 36px;
    /* 
      MC-318 - Alice Serina - 05/02/2026
      288px is the minimum screen supported witdth (320px with 16px padding on each side).
      max-width is set to avoid becoming as wide as the screen
    */
    min-width: 288px;
    max-width: 360px;
    border: 2px solid #000000;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
    background: none !important;
}

/* Botão Normal */
.custom-toggle .v-btn {
  flex: 1;
  min-width: 140px;
  max-width: 70%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  color: rgb(0, 0, 0);
  background-color: #e9cfed ;
  border-radius: 0px;
  font-size: 16px;
  font-style: normal;
  text-decoration: none;
  text-transform: none;
  transition: background-color 0.3s, color 0.3s;
  font-size: 0.7rem;
}

.custom-toggle .v-btn:before {
    box-shadow: none !important;
    background: transparent !important;
}

::v-deep .v-input--selection-controls__input:hover .v-input--selection-controls__ripple::before {
  background: transparent !important;
  box-shadow: none !important;
}

/* Botão Ativo */
.custom-toggle .v-btn.active-btn {
  background-color: black;
  color: #e9cfed !important;
}

/* Ícones */
.custom-toggle .v-icon {
  font-size: 25px;
  padding: auto;

}

.icon-active-calendar {
  color: #e9cfed !important; /* Cor específica para o ícone ativo do calendário */
}

.icon-active-results {
  color: #e9cfed !important; /* Cor específica para o ícone ativo dos resultados */
}

.icon-inactive {
  color: rgb(0, 0, 0); /* Cor para ícones inativos */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  position: sticky;
  top: 0;
  background-color: transparent;
  z-index: 10;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 17px;
}


.add-btn-email {
    
    color: #e9cfed !important;
}

.check-icon {
    color: #cbd8c7 !important;
}

.close-icon {
    color: #fa9a9a !important;
}

.fixed-container {
  position: fixed;
  top: 120px;
  left: 50px;
  bottom: 0px;
  max-height: 72%;
  height: 100dvh; /* Altura total da viewport */
  overflow: hidden; /* Oculta a barra de rolagem */
  display: flex;
  flex-direction: column; 
  justify-content: flex-start;
  align-items: flex-start; 
  width: 100%;

}

.floating-save-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.red-button {
    background-color: #fa9a9a;
    color: #fa9a9a
  }

  .yellow-button {
    background-color: #f5e720;
    color: #f5e720;
  }

  .green-button {
    background-color: #cbd8c7;
    color: #cbd8c7;
  }

  .dialog-body{
    background-color: #fff;
    
  }

  .modal-partilhar-title {
    font-family: 'Urbane Rounded', sans-serif !important;
    font-size: 1.25rem !important;
  }

@media (max-width: 768px) {

  .btn-left {
    margin-left: 20px;
    margin-right: 0;
  }

  .event-title{
    max-width: 230px;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    margin-bottom: 0;
  }

  .fixed-container {
    top:80px;
    left: 0;
  }

  .custom-toggle{
    width: 100%;
    height: 40px;
  }

  .custom-toggle .v-btn{
    font-size: 12px;
    font-weight: bold;
    min-width: 120px;
    max-width: 100%;
  }
}

@media (max-width: 979px) {
    
    .custom-toggle-container {
      background-color: #e9cfed;
      padding: 0.5rem 1.5rem 1rem 1.5rem;
    }

}

.dialog-body {
  flex: 1;
  overflow-y: auto;
}

</style>